export const HOME = "/";
export const ALL_COMPANIES = "/all-companies";
export const COMPANY = "/company";
export const CALL_COURIER = "/call-courier";
export const CONFIRMATION = "/confirmation";
export const PROFILE = "/profile";
export const TRACK_CARGO = "/track-cargo";
export const FAQ = "/faq";
export const ABOUT = "/about";
export const BLOG = "/blog";

/* Subroutes */
export const MY_CARGOS = "/my-cargos";
export const MY_ADDRESSES = "/addresses";
export const SETTINGS = "/settings";
export const NOTIFICATIONS = "/notifications";
export const ADD_ADDRESS = "/add-address";
